import { render, staticRenderFns } from "./present-card.vue?vue&type=template&id=1a03bbfb&scoped=true&"
import script from "./present-card.vue?vue&type=script&lang=js&"
export * from "./present-card.vue?vue&type=script&lang=js&"
import style0 from "./present-card.vue?vue&type=style&index=0&id=1a03bbfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03bbfb",
  null
  
)

export default component.exports